import React from 'react';

function LeftIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      fill="none"
      viewBox="0 0 18 19"
      {...props}
    >
      <path
        fill="#FF8A00"
        d="M11.25 15.5a.683.683 0 00.525-.224c.3-.298.3-.745 0-1.043L7.05 9.463l4.725-4.696c.3-.298.3-.745 0-1.043a.728.728 0 00-1.05 0L5.475 8.94a.675.675 0 00-.225.522c0 .223.075.372.15.521l5.25 5.218c.225.223.375.298.6.298z"
      ></path>
    </svg>
  );
}

export default LeftIcon;
